import axios from 'axios';
import { logError } from './logger';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Tempo minimo col player/modale aperto prima di segnare "completato" alla chiusura.
 * Prima era 180s: i video più corti non venivano mai completati anche se visti per intero.
 */
export const VIDEO_AUTO_COMPLETE_MIN_MS = 45 * 1000;

/** Documenti in anteprima: dopo quanto tempo di lettura contano come completati. */
export const DOCUMENT_AUTO_COMPLETE_MIN_MS = 20 * 1000;

export function markProgressComplete(contentId) {
  if (!contentId) return;
  axios.post(`${API}/progress/complete`, { content_id: contentId }).catch((e) => {
    logError('progressAutoComplete:complete', e);
  });
}

export function tryAutoCompleteVideoOnClose(contentId, openedAtMs) {
  if (!contentId || !openedAtMs) return;
  if (Date.now() - openedAtMs < VIDEO_AUTO_COMPLETE_MIN_MS) return;
  markProgressComplete(contentId);
}

/** HTML5 video arrivato a fine riproduzione → completato subito. */
export function tryAutoCompleteVideoOnEnded(contentId) {
  markProgressComplete(contentId);
}

export function tryAutoCompleteDocumentOnClose(contentId, openedAtMs) {
  if (!contentId || !openedAtMs) return;
  if (Date.now() - openedAtMs < DOCUMENT_AUTO_COMPLETE_MIN_MS) return;
  markProgressComplete(contentId);
}

/** Documenti: dopo download riuscito dall’anteprima. */
export function markProgressCompleteOnDownload(contentId) {
  markProgressComplete(contentId);
}
